<template>
  <div class="mt-5" v-if="results.lines.length">
    <vs-alert class="h-auto" :title="showDetails ? title : null" :color="color">
      <p v-if="!showDetails">
        {{ title }}
      </p>
      <ul v-else>
        <li class="mb-3" v-for="line of results.lines" :key="line">
          <vs-alert :title="`Line ${line}`">
            <ul>
              <li class="mb-1" v-for="(value, key) in results[line]" :key="key">
                <vs-alert :title="key">
                  <p v-if="typeof value === 'string'">{{ value }}</p>

                  <ul v-else>
                    <li class="mb-1" v-for="(obj, index) of value" :key="index">
                      <vs-alert>
                        <p v-for="(value, key) in obj" :key="key">
                          {{ key }}: {{ value }}
                        </p>
                      </vs-alert>
                    </li>
                  </ul>
                </vs-alert>
              </li>
            </ul>
          </vs-alert>
        </li>
      </ul>
    </vs-alert>
  </div>
</template>
<script>
export default {
  name: 'ResultsTree',
  props: {
    results: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      const {
        type,
        results: { lines },
      } = this
      return `${type} in lines ${lines}`
    },
  },
}
</script>
